import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useState } from "react";
import { useEffect } from "react";
import { addtoCard } from "../redux/actions/productAction";
import { removeselectedproduit } from "../redux/actions/productAction";
import axios from "axios";
import { setCategProducts } from "../redux/actions/productAction";
import Spinner from "./spinner/Spinner";

const ProduitCategorie = () => {
  const Ajout = (x) => {
    dispatch(addtoCard(x));
    toast.success("Le Produit est bien ajouter dans le panier!", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const categoDesProduits = useSelector(
    (state) => state.lesCategProduits.categProduits
  );

  const dispatch = useDispatch();

  const { categorie } = useParams();

  const [loading, setLoading] = useState(true);
  const fetchCategories = async (categ) => {
    // <img src={Spinner} alt='Loading' style={{width: "500px", height: "500px"}}/>
    setLoading(true);
    try {
      const response = await axios.get(
        `https://fakestoreapi.com/products/category/${categ}`
      );
      dispatch(setCategProducts(response.data));
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (categorie && categorie !== "") {
      fetchCategories(categorie);
    }
    return () => {
      dispatch(removeselectedproduit());
    };
  }, [categorie]);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <h1 style={{ margin: "2rem" }}>Categorie: {categorie}</h1>
          <>
            <ToastContainer
              position="top-right"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />

            <div class="container">
              {categoDesProduits.map((produit) => {
                const { id, category, image, title } = produit;
                return (
                  <div key={id} class="card">
                    <div class="card__thumb">
                      <img
                        src={image}
                        alt="Picture by Kyle Cottrell"
                        class="card__image"
                      />
                      <div class="card__caption">
                        <h2 class="card__title">{category}</h2>
                        <p class="card__snippet">{title}.</p>
                        <Link className="linkBtn" to={`/produits/${id}`}>
                          <div class="card__button">Detail</div>
                        </Link>
                        <button
                          type="button"
                          class="card__button"
                          onClick={() => Ajout(produit)}
                        >
                          Ajouter au Panier
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        </>
      )}
    </>
  );
};

export default ProduitCategorie;
